import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = () => {
  return (
    <div class="container">
      <div class="spinner-wrapper">
        <div class="spinner"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
